import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "../Cards/Card";
import { Grid, styled } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import MediaMensal from "../../assets/icons/Simulador/media-mensal.svg";
import ValorTotal from "../../assets/icons/Evolution/total-value.svg";
import PDVCompra from "../../assets/icons/Evolution/pdv-compra.svg";
import SKUComprados from "../../assets/icons/Evolution/sku-comprados.svg";

import ComboHeader from "../../components/ComboHeader/ComboHeader";
import NativeObject from "../../components/NativeObject/NativeObject";
import Kpi from "./Kpi";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(46,46,46, 0.9)",
    color: "white",
    width: 280,
    fontSize: "12px",
    border: "1px solid #dadde9",
    opacity: "0.5",
  },
  "& .MuiTooltip-arrow": {
    color: "#2e2e2e",
  },
}));

function KpiCardEvolution({
  app,
  KPITitle,
  iconId,
  percentageId,
  greyValueId,
  valueId,
  customStyle,
  tooltipId,
}) {
  const [loading, setLoading] = useState(true);
  const [vDataIni, setVDataIni] = useState("");
  const [vDataFim, setVDataFim] = useState("");

  function getIcon(icon) {
    switch (icon) {
      case "valor-total":
        return ValorTotal;
      case "media-mensal":
        return MediaMensal;
      case "sku-comprados":
        return SKUComprados;
      case "pdv-compra":
        return PDVCompra;
      default:
        return "";
    }
  }

  const [percentage, value, greyValue] = [
    Kpi({ app, objectId: percentageId, updatesWithSelection: true }),
    Kpi({ app, objectId: valueId, updatesWithSelection: true }),
    Kpi({ app, objectId: greyValueId, updatesWithSelection: true }),
  ];

  return (
    <HtmlTooltip
      arrow
      title={
        <React.Fragment>
          <h2>{KPITitle.hardTitle}</h2>
          <div>
            <span>{vDataIni}</span>
          </div>
          <div
            style={{
              width: "100%",
              justifyContent: "center",
              display: "flex",
              marginTop: "8px",
              marginBottom: "8px",
            }}
          ></div>
          <h2>Last {KPITitle.hardTitle}</h2>
          <div style={{ marginBottom: "16px" }}>
            <span>{vDataFim}</span>
          </div>
          <div
            className="container-kpi-tooltip"
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "60px",
              alignItems: "center",
            }}
          >
            <span style={{ fontSize: "18px" }}>Diferença:</span>
            <NativeObject
              className="kpi-value-tooltip"
              app={app}
              key={tooltipId}
              reference={{ id: tooltipId }}
              style={{ height: "100%" }}
            />
          </div>
        </React.Fragment>
      }
    >
      <Card
        style={{
          width: "100%",
          padding: "16px",
          ...customStyle,
        }}
      >
        <Grid
          className="kpiCardWrapper"
          container
          flexDirection={"column"}
          justifyContent={"flex-start"}
          alignItems={"center"}
          rowGap={0.5}
        >
          <Grid
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Grid item xs={9}>
              {/* TITULO */}
              <ComboHeader
                reference={{
                  title: {
                    hard: KPITitle.hardTitle,
                  },
                }}
              tooltip={KPITitle.tooltip}
              />
            </Grid>
            <Grid
              item
              container
              flexDirection={"row"}
              justifyContent={"flex-end"}
              xs
            >
              {/* PORCENTAGEM */}
              <span className="percentage">{percentage}</span>
            </Grid>
          </Grid>
          <Grid
            container
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            columnGap={1}
            /* style={{
              border: "1px solid #dadde9",
            }} */
          >
            <Grid item sx={{ padding: "8px" }} xs={3.5}>
              {/* ICON*/}
              <img
                src={getIcon(iconId)}
                style={{ width: "46px", height: "46px" }}
                alt=""
              ></img>
            </Grid>
            <Grid
              item
              container
              flexDirection={"column"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
              rowGap={1}
              xs
            >
              <Grid item>
                {/* GREY VALUE */}
                <span className="grey-value">{greyValue}</span>
              </Grid>
              <Grid item>
                {/* VALUE */}
                <span className="value">{value}</span>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </HtmlTooltip>
  );
}

KpiCardEvolution.defaultProps = {
  app: null,
  KPITitle: {},
  iconId: null,
  percentageId: null,
  greyValueId: null,
  valueId: null,
  customStyle: {},
  tooltipId: ""
};

KpiCardEvolution.propTypes = {
  app: PropTypes.object,
  KPITitle: PropTypes.object,
  iconId: PropTypes.string,
  percentageId: PropTypes.string,
  greyValueId: PropTypes.string,
  valueId: PropTypes.string,
  customStyle: PropTypes.object,
  tooltipId: PropTypes.string,
};

export default KpiCardEvolution;
